/********************************************
 * Split text by lines and reveal
 ********************************************/
function fnSplitText(i, oSection) {

	// Split text by lines
	var oTarget = $(this),
	 	oSection = oTarget.parents('.view-detect'),
		oResults = Splitting({target: oTarget, by: 'chars'});

	fnSplittedTextReveal(oTarget, oResults);

	// locoScroll.on('scroll', (instance) => {
	// 	fnSplittedTextReveal(oTarget, oResults);
	// });

	//Splitted Text Reveal
	function fnSplittedTextReveal(oTarget, oResults) {
			oResults.forEach( s => {

				s.chars.forEach( char => {
					char.style.setProperty('--random', Math.random());
				});

			});
			// oTarget.addClass('revealed');
		// if (oSection.hasClass('viewed') && (!oTarget.hasClass('revealed'))) {
		// }
	}
}


/* END OF DOCUMENT */
